import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const CALENDLY_URL = "https://calendly.com/leonie-honban-herusaxiom/30min";

const track = (data) => axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/booking-events`, data).catch(() => {});

const embedUrl = (page) => {
  const u = new URL(CALENDLY_URL);
  u.searchParams.set("hide_gdpr_banner", "1");
  u.searchParams.set("primary_color", "c5a059");
  u.searchParams.set("embed_domain", window.location.hostname);
  u.searchParams.set("embed_type", "Inline");
  u.searchParams.set("utm_source", "herusaxiom.com");
  u.searchParams.set("utm_content", page);
  return u.toString();
};

const BTN = "inline-flex items-center gap-2 border border-[#C5A059] text-[#C5A059] text-xs uppercase tracking-[0.2em] px-6 py-4 hover:bg-[#C5A059] hover:text-[#0A0A0A] transition-colors duration-500";

export const BookingButton = ({ label = "Réserver un échange de 30 min", testId = "booking-btn", className = BTN, iconSize = 16 }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!open) return;
    const onMessage = (e) => {
      if (e.origin !== "https://calendly.com" || e.data?.event !== "calendly.event_scheduled") return;
      const p = e.data.payload || {};
      track({ type: "scheduled", page: pathname, event_uri: p.event?.uri, invitee_uri: p.invitee?.uri });
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [open, pathname]);

  if (!CALENDLY_URL) return null;
  const openDialog = () => {
    setOpen(true);
    track({ type: "open", page: pathname });
  };
  return (
    <>
      <button
        type="button"
        onClick={openDialog}
        data-testid={testId}
        className={className}
      >
        <CalendarClock size={iconSize} /> {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-lenis-prevent data-testid="booking-dialog" className="max-w-4xl w-[95vw] p-0 bg-[#F9F6F0] border-[#C5A059] rounded-none overflow-hidden">
          <div className="bg-[#0A0A0A] px-6 py-5 border-b border-[#C5A059]">
            <DialogTitle className="font-serif-display text-xl text-[#F9F6F0] font-light">{label}</DialogTitle>
            <DialogDescription className="text-xs uppercase tracking-[0.2em] text-[#C5A059] mt-1">Léonie Stéphanie HONBAN · HERUS AXIOM</DialogDescription>
          </div>
          {open && <iframe title={label} src={embedUrl(pathname)} data-testid="booking-iframe" className="w-full h-[70vh] border-0" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
